function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppleIcon = function SvgAppleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-2 0h24v24H-2z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M19.341 18.703c-.35.839-.764 1.61-1.244 2.32-.655.968-1.19 1.637-1.604 2.01-.64.61-1.326.922-2.06.94-.528 0-1.164-.156-1.904-.471-.742-.314-1.425-.47-2.049-.47-.654 0-1.356.156-2.107.47-.752.315-1.358.48-1.82.496-.705.031-1.407-.29-2.108-.966-.447-.404-1.007-1.098-1.677-2.08-.719-1.049-1.31-2.265-1.773-3.652C.499 15.803.25 14.352.25 12.948c0-1.608.335-2.995 1.007-4.158a6.022 6.022 0 0 1 2.108-2.21 5.523 5.523 0 0 1 2.85-.835c.56 0 1.294.18 2.206.532.909.354 1.492.533 1.748.533.192 0 .84-.21 1.94-.628 1.04-.388 1.916-.548 2.635-.485 1.948.163 3.411.96 4.384 2.393-1.742 1.094-2.603 2.627-2.586 4.593.016 1.531.552 2.806 1.605 3.817.477.47 1.01.833 1.603 1.09-.129.387-.264.758-.409 1.113zM14.874.48c0 1.2-.423 2.321-1.266 3.358-1.017 1.234-2.248 1.946-3.582 1.834a3.87 3.87 0 0 1-.027-.455c0-1.152.484-2.386 1.343-3.394.429-.51.974-.935 1.636-1.273.66-.334 1.285-.518 1.872-.55.017.16.024.32.024.48z",
    style: {
      fill: "#000"
    }
  })));
};
export default SvgAppleIcon;